import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-title-personal-information',
  imports: [CommonModule, TranslateModule],
  template: `
    <h2>{{ 'users.user-profile.personal-information' | translate }}</h2>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitlePersonalInformationComponent {}
